import { useEffect, useRef } from 'react'
import { getAlert } from '../components/appBar/context/AlertsContext'
import { useDataPendingSendStore } from '../redux/zustand/dataPendingSendStore'

export const useLiveProgressAlert = () => {
    const { updateAlertText, isLive, closeAlert } = getAlert()
    const pendingsSend = useDataPendingSendStore((store) => store.pendingsSend)
    const progressTotalModal = useDataPendingSendStore((store) => store.progressTotalModal)
    const progress = useDataPendingSendStore((store) => store.progress) // Usar el progress del store
    
    const closingAlert = useRef(false) // Flag para evitar múltiples cierres

    const generateAlertText = () => {
        // console.log('generateAlertText => ')
        // console.log('progress del store => ', progress)
        // console.log('progressTotalModal => ', progressTotalModal)
        // console.log('pendingsSend => ', pendingsSend)
        
        // const itemsSent = Math.max(0, progressTotalModal - pendingsSend)
        
        // if (progress === 100 && pendingsSend === 0 && progressTotalModal > 0) {
        //     return `✅ ¡Envío completado! 100% (${progressTotalModal}/${progressTotalModal})`
        // }
        
        // return `Enviando formularios, no cierres la app... ${progress}% `
        return `Tienes datos pendientes. Se estarán enviando mientras la App permanezca abierta.`
        // return `Enviando formularios, no cierres la app ${progress}% (${itemsSent}/${progressTotalModal})`
    }

    useEffect(() => {
        // console.log('useEffect triggered => isLive => ', isLive)
        if (isLive) {
            // Si no hay pendientes y no hay total, cerrar la alerta (solo una vez)
            if (pendingsSend === 0 && progressTotalModal === 0) {
                if (!closingAlert.current) {
                    closingAlert.current = true
                    setTimeout(() => {
                        // console.log('🔐 Cerrando alerta - no hay datos pendientes')
                        closeAlert()
                        closingAlert.current = false // Reset flag para próxima vez
                    }, 1000) // 1 segundo de delay
                }
                return
            }
            
            // Si completamos todo (100% y pendientes = 0), cerrar después de mostrar éxito
            if (progress === 100 && pendingsSend === 0 && progressTotalModal > 0) {
                if (!closingAlert.current) {
                    // const successText = `✅ ¡Envío completado! 100% (${progressTotalModal}/${progressTotalModal})`
                    const successText = `✅ ¡Envío completado! 100%`
                    // updateAlertText(successText) // comento para no updatear el texto
                    // console.log('🎉 Mostrando mensaje de éxito, cerrando en 2 segundos...')
                    
                    closingAlert.current = true
                    // Cerrar la alerta después de 2 segundos
                    setTimeout(() => {
                        closeAlert()
                        // console.log('🔐 Alerta cerrada después de completar envío')
                        closingAlert.current = false // Reset flag para próxima vez
                    }, 2000)
                }
                return
            }
            
            // Actualizar texto normal (solo si no estamos cerrando)
            if (!closingAlert.current) {
                const newText = generateAlertText()
                updateAlertText(newText)
            }
        }
    }, [pendingsSend, progressTotalModal, progress, isLive])

    return {
        generateAlertText,
    }
}
